'use strict';

var tooSexy = {
  name: 'tooSexy',
  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#5a0302',
  borderDarkest: '#000000',
  borderLight: '#c81d19',
  borderLightest: '#fe5757',
  canvas: '#FFF1D0',
  canvasText: '#000000',
  canvasTextDisabled: '#5a0302',
  canvasTextDisabledShadow: '#FFF1D0',
  canvasTextInvert: '#ffffff',
  checkmark: '#000000',
  checkmarkDisabled: '#5a0302',
  flatDark: '#9e9e9e',
  flatLight: '#d8d8d8',
  focusSecondary: '#fefe03',
  headerBackground: '#161B33',
  headerNotActiveBackground: '#5a0302',
  headerNotActiveText: '#B80100',
  headerText: '#FFF1D0',
  hoverBackground: '#474973',
  material: '#B80100',
  materialDark: '#9a9e9c',
  materialText: '#000000',
  materialTextDisabled: '#5a0302',
  materialTextDisabledShadow: '#fe5757',
  materialTextInvert: '#ffffff',
  progress: '#474973',
  tooltip: '#fefbcc'
};

module.exports = tooSexy;
